// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"dc7fc5242849f9d4d8d7","453":"298c5f8198e8d1c49e39","522":"19ef7d11197b96b04309"}[chunkId] + ".js";
};